import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStackedBarChart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.196 19.021 4 18.55 4 18V9H8V18C8 18.55 7.804 19.021 7.412 19.413C7.02067 19.8043 6.55 20 6 20ZM4 8V6C4 5.45 4.196 4.97933 4.588 4.588C4.97933 4.196 5.45 4 6 4C6.55 4 7.02067 4.196 7.412 4.588C7.804 4.97933 8 5.45 8 6V8H4ZM12 20C11.45 20 10.9793 19.8043 10.588 19.413C10.196 19.021 10 18.55 10 18V12H14V18C14 18.55 13.8043 19.021 13.413 19.413C13.021 19.8043 12.55 20 12 20ZM10 11V9C10 8.45 10.196 7.979 10.588 7.587C10.9793 7.19567 11.45 7 12 7C12.55 7 13.021 7.19567 13.413 7.587C13.8043 7.979 14 8.45 14 9V11H10ZM18 20C17.45 20 16.979 19.8043 16.587 19.413C16.1957 19.021 16 18.55 16 18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8043 18.55 20 18 20ZM16 14V12C16 11.45 16.1957 10.979 16.587 10.587C16.979 10.1957 17.45 10 18 10C18.55 10 19.021 10.1957 19.413 10.587C19.8043 10.979 20 11.45 20 12V14H16Z",
		fill: "currentColor"
	})
});
export default SvgStackedBarChart;
